export class StartScreenViewEvents {
	public static readonly INTRO_STARTED: string = 'StartScreenViewEvents::GAME_VIEW_INTRO_STARTED';
	public static readonly INTRO_IDLE: string = 'StartScreenViewEvents::GAME_VIEW_INTRO_IDLE';
	public static readonly INTRO_FINISHED: string = 'StartScreenViewEvents::GAME_VIEW_INTRO_FINISHED';
	public static readonly EXIT_STARTED: string = 'StartScreenViewEvents::GAME_VIEW_INTRO_EXIT_STARTED';
	public static readonly EXIT_FINISHED: string = 'StartScreenViewEvents::GAME_VIEW_INTRO_EXIT_FINISHED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/startscreen/StartScreenViewEvents.ts